import * as R from 'ramda'
import fileDialog from 'file-dialog'
import G from '../util/globalFunction'
import { serverUrl } from '../config'
import tremApi from './tremApi'
import pdfMake from "pdfmake/build/pdfmake"
import html2canvas from 'html2canvas'

// 서류 발행 현황개수
export const setPrintCount = params => { //DOC_PRT_TYPE, DOC_PRT_NO, REF_SKEY, REF_NAME
    
    let res = tremApi('/r/doc/print/info/save', G.removeEmptyUndefinedOrNull(params))
    .then(()=>{ 
        return true 
        })
    .catch(()=>{
        return false
    })

   
    return res
}


// pdf 출력
export const createPdfFormHtml = async documentProps =>{ 
    const pdfProps = await createPdfProps(documentProps);
    createPdf(pdfProps , documentProps?.title);
}

const createPdfProps = async documentProps =>{
    const {element, canvWidth, canvHeight, contentWidth, contentHeight, marginRight, marginLeft} = documentProps
    const RATE = 2.83464566929;
    const PAGE_WIDTH = canvWidth * RATE; // canvas 가로 size
    const PAGE_HEIGHT = canvHeight * RATE; // canvas 세로 size

    const CONTENT_WIDTH = PAGE_WIDTH - contentWidth; // 컨텐츠 가로
    const CONTENT_HEIGHT = PAGE_HEIGHT - contentHeight; // 컨텐츠 세로

    const PAGE_MARGINS = [marginRight * RATE, marginLeft * RATE]; // 여백(오른쪽, 왼쪽)
    
    const options = {
      scale: 2
    };

    const canvas = await html2canvas(element, options);
  
    const dataUrl = canvas.toDataURL();
  
    const pdfProps = {
      dataUrl,
      pageSize: {
        width: PAGE_WIDTH,
        height: PAGE_HEIGHT
      },
      pageOrientation: "PORTRAIT",
      contentSize: {
        width: CONTENT_WIDTH,
        height: CONTENT_HEIGHT
      },
      pageMargins: PAGE_MARGINS
    };
  
    return pdfProps;
}

const createPdf = (pdfProps, title) => {
    const { dataUrl, contentSize, pageMargins } = pdfProps;
    const pageSize = pdfProps.pageSize;
    const pageOrientation = pdfProps.pageOrientation;
  
    const documentDefinitions = {
      pageSize,
      pageOrientation,
      content: {
        image: dataUrl,
        ...contentSize
      },
      pageMargins
    };
  
    pdfMake.createPdf(documentDefinitions).download(title);
}

